import { Star } from "lucide-react";
import { BookLink, GOOGLE_LISTING_URL, Reveal } from "./booking";

export default function Reviews() {
  return (
    <section
      id="reviews"
      data-testid="reviews-section"
      className="px-5 lg:px-12 py-24 lg:py-40 border-t border-border text-center relative overflow-hidden"
    >
      <div className="flex justify-center gap-1 mb-8" aria-label="Rated by our clients">
        {[...Array(5)].map((_, i) => (
          <Star key={i} size={18} className="text-primary fill-primary" aria-hidden="true" />
        ))}
      </div>
      <Reveal>
        <h2 className="font-display uppercase leading-[0.85] text-[13vw] sm:text-8xl lg:text-9xl">
          Ready for your
          <br />
          <span className="text-primary">next cut?</span>
        </h2>
      </Reveal>
      <Reveal delay={0.15}>
        <p className="mt-8 max-w-md mx-auto text-base sm:text-lg text-muted-foreground font-light leading-relaxed">
          Walk-ins welcome, chairs fill fast. Lock in your spot online — it takes less than a
          minute.
        </p>
      </Reveal>
      <Reveal delay={0.25} className="mt-10 flex flex-col items-center gap-6">
        <BookLink testid="reviews-book-button" className="btn-primary !px-12 !py-5 !text-base">
          Book Your Appointment
        </BookLink>
        <a
          href={GOOGLE_LISTING_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="google-review-link"
          className="text-link"
        >
          Been in the chair? Leave us a Google review
        </a>
      </Reveal>
    </section>
  );
}
